import { Route, BrowserRouter, useNavigate as Router, Routes, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

import { NotificationProvider } from './utils/notifications';

import Session from './utils/session';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Login from './pages/Login/Login';
import DashboardView from './pages/Dashboard/Dashboard';
import Reports from './pages/Reports/Reports';
import Error from './components/Error/Error';
import Settings from './pages/Settings/Settings';
import Users from './pages/Users/Users';
import UserView from './pages/User/User';
import Organizations from './pages/Organizations/Organizations';
import Activity from './pages/Activity/Activity';

import { 
  urlHome, urlLogin,
  urlAll,
  urlUsers,
  urlUser,
  urlOnboard,
  getToken, systemLanguage,
  languages, enUS,
  getLanguage, setLanguage, authToken, 
  signOutService, menuOpen, getMenuOpened,
  checkRequiredParams,
  urlReports,
  urlOrganizations,
  urlSettings,
  urlOrganization,
  urlActivity
} from './utils/constants';
import OrganizationView from './pages/Organization/Organization';



function App() {

  const navigate = useNavigate()

  const [token, setToken] = useState<string>(getToken());
  const [menuOpened, setMenuOpenedIs] = useState<string>(getMenuOpened());

  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(!!token);
  const [isMenuOpened, setIsMenuOpened] = useState<boolean>(false)

  const [sessionLang,setSessionLang] = useState<string>(getLanguage());

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === authToken) {
        const newToken = event.newValue;
        setToken(newToken || '');
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  useEffect(() => {
    if (token) {
      setIsAuthenticated(true); 
    } else {
      setIsAuthenticated(false); 
    }
  }, [token]);

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === menuOpen) {
        const newMenuOpenStatus = event.newValue;
        setMenuOpenedIs(newMenuOpenStatus || 'false');
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  useEffect(() => {
    if (menuOpened === 'true') {
      setIsMenuOpened(true); 
    } else {
      setIsMenuOpened(false); 
    }
  }, [menuOpened]);

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === systemLanguage) {
        const newLanguage = event.newValue;
        setLanguage(newLanguage || '');
        setSessionLang(newLanguage || '')
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  useEffect(() => {
    if (!sessionLang || sessionLang === "") {
      const defaultLang = languages(enUS);
      setLanguage(JSON.stringify(defaultLang))
    }
  }, [sessionLang]);
  
  const handleGoHome = () => {
    navigate(urlHome);
  }

  const handleSignOut = async () => {
    setIsAuthenticated(false)
    signOutService()
    handleGoHome()
  };

  const requirements = checkRequiredParams()
  if(!requirements && isAuthenticated){
    handleSignOut()
  }

  const isOnboardingPath = (url = window.location.pathname) => {
    const [firstSegment] = url.replace(/^\/+|\/+$/g, "").split("/");
    return '/' + firstSegment === urlOnboard;
  }
  
  return (
    <>
      <Session activeToken={token} unAuthenticate={handleSignOut} isOnboarding={isOnboardingPath()} />
      <NotificationProvider>
      {
        isAuthenticated ?
          <Header isAuthenticated={isAuthenticated} handleSignOut={handleSignOut} language={sessionLang} /> : ''
      }
      <div className="App">
        <div className={`${isAuthenticated && isMenuOpened ? "view-container" : "view-container full"}`}>
          <Routes>
            <Route path={urlHome} element={<DashboardView />} />
            <Route path={urlLogin} element={<Login />} />
            <Route path={urlReports} element={<Reports />} />
            <Route path={urlUsers} element={<Users />} />
            <Route path={urlUser+'/:user_uuid'} element={<UserView />} />
            <Route path={urlUser+'/:user_uuid/:action'} element={<UserView />} />
            <Route path={urlUser+'/:user_uuid'+urlActivity} element={<Activity />} />
            <Route path={urlOrganizations} element={<Organizations />} />
            <Route path={urlOrganization+'/:org_id'} element={<OrganizationView />} />
            <Route path={urlOrganization+'/:org_id/:action'} element={<OrganizationView />} />
            <Route path={urlSettings} element={<Settings />} />
            <Route path={urlAll} element={<Error />} />
          </Routes>
        </div>
      </div>
      <Footer />
      </NotificationProvider>
    </>

  );
}

export default App;
